import ListAlt from '@material-ui/icons/ListAlt'

export const getFileExtensionIcon = (filename) => {
  const re = /(?:\.([^.]+))?$/
  switch (re.exec(filename)[1]) {
    case 'pdf':
      return <img src="/img/PDF_file_icon.svg" style={{ width: '2rem' }} />
    case 'docx':
      return <img src="/img/Microsoft_Office_Word.png" style={{ width: '2rem' }} />
    case 'odt':
      return <img src="/img/Microsoft_Office_Word.png" style={{ width: '2rem' }} />
    default:
      return <ListAlt fontSize="large" style={{ color: '#4d4d4d' }} />
  }
}
